import React from "react";
import api from "src/store/features/api";
import DefaultRaFAnalytics from "./DefaultRPAnalytics";
import RaFAnalytics from "./RPAnalytics";
import { styled } from "@mui/styles";
import { LoadingSpinner } from "src/components/application/LoadingSpinner";
import Layout from "src/components/core/Layout";
import ReferralProgress from "src/components/Referral-partner/Analytics/ReferralProgress";

const LoadingWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "80vh",
}));

const Message = styled("div")(() => ({
  fontSize: "18px",
  color: "#4A5568",
  marginBottom: "16px",
  lineHeight: 1.5,
}));

const MINIMUM_REFERRALS = 15;

const RPAnalyticsContainer = () => {
  const [useDefaultTheme, toggle] = React.useReducer((theme: any) => !theme, true);
  const { data: rpCode, isLoading: rpCodeIsLoading } = api.useGetReferralCodeQuery();
  const { data: referralCount, isLoading: referralCountIsLoading } =
    api.useGetReferralsCountQuery();

  if (rpCodeIsLoading || referralCountIsLoading) {
    return (
      <Layout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
        <LoadingWrapper>
          <LoadingSpinner size={40} />
        </LoadingWrapper>
      </Layout>
    );
  }

  if (rpCode?.referralCode === undefined) {
    return (
      <DefaultRaFAnalytics
        title="Unable to view analytics"
        description1="Switch user to a Referral Partner affiliated user to see analytics"
      />
    );
  }

  if (referralCount && referralCount.count < MINIMUM_REFERRALS) {
    return (
      <DefaultRaFAnalytics
        title="Not Enough Referrals!"
        description1={({ requiredReferrals, currentReferrals }) => (
          <Message>
            To access the analytics dashboard, you need {requiredReferrals} successful referrals.
            {currentReferrals > 0 && (
              <>
                {" "}
                You currently have {currentReferrals} referral
                {currentReferrals !== 1 ? "s" : ""}.
              </>
            )}
          </Message>
        )}
        description2={({ remaining }) => (
          <ReferralProgress currentReferrals={referralCount.count} />
        )}
      />
    );
  }

  return <RaFAnalytics />;
};

export default RPAnalyticsContainer;
